/**
 * 小説公開ステータス
 * 現状では0, 7の値しか使っていない
 */
export enum NovelStatus {
  DRAFT, // 未公開
  REQUEST_REVIEW, // 公開申請, 再申請
  UNDER_REVIEW, // 校閲中
  SEND_BACKED, // 差戻し
  AVAILABLE_FOR_SALE,
  SALE, // 商品登録完了
  END_SALE, // 有料公開完了
  RELEASE_FOR_FREE, // 公開（処理完了）、無料作品も有料作品も公開中はこのステータス
}
